import { Injectable } from '@angular/core';
import { QuestionnaireService } from './questionnaire.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UpdateDraftData } from '../models/UpdateDraftData';
import { CheckBorrower_Request } from '../models/CheckBorrower_Request.model';
import { UserEntity } from '../models/UserEntity.model';
import { IdTypeEnum } from '../enums/IdTypeEnum.enum';
import { SetBorrowers_Request } from '../models/SetBorrowers_Request.model';
import { DraftHttpService } from './draft-http.service';
import { LoanEntity } from '../models/LoansEntity.model';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { UpdateOpportunity_Request } from '../models/UpdateOpportunity_Request.model';
import { SendTMFinal_Request } from '../models/SendTMFinal_Request.model';
import { SystemTablesService } from '../services/system-tables.service';
import { LeadService } from './lead.service';

@Injectable()
export class Draft {
  autoForm = false;
  isBuildForm = false;
  showLastSavedQuestion = false;
  saveArrDataBasetmp = [];
  arrDataBase = [];
  apiUri = environment.apiUri + "/TofesMashkanta";
  // listCreateCustomer: UserEntity[] = [];
  listCreateCustomerBorrowersArray: UserEntity[] = [];
  createCustomerMainBorrower: UserEntity[] = [];
  listLoansArrayforCreateOpp: LoanEntity[] = [];
  mainLoanArrayforCreateOpp: LoanEntity[] = [];
  isAfterStep1 = false;
  isUpdateable: boolean = false;
  flagSendToServer = false;
  indexCheckBorrower = 0;
  ConsultantId: string;
  ConsultantIdnt: string;
  ConsultFirmId: string;
  emailOrApp: string;
  CustomerId: "";
  SourceID = "";
  IsContractSigned = "";
  // observable source
  _checkBorrowerStatus = new BehaviorSubject<any>(0);
  // observable stream
  checkBorrowerStatus$ = this._checkBorrowerStatus.asObservable();

  constructor(
    private questionnaireService: QuestionnaireService,
    private httpClient: HttpClient,
    private systemTablesService: SystemTablesService,
    private leadService: LeadService,
    private draftHttp: DraftHttpService) {
    this.showLastSavedQuestion = true;
  }

  buildForm(currentStep, control) {
    this.arrDataBase.forEach((element1, index1) => {
      if (element1.stepName === currentStep.stepName) {

        let element1Tmp = JSON.parse(JSON.stringify(element1))

        element1Tmp.answers.forEach((element2, index2) => {

          control = this.buildArray(control, element1Tmp, element2, index2);

          switch ((element1Tmp.systemTable)) {
            case "stringTable":
              if (this.systemTablesService.getTable(element1Tmp.numberSystemTable[index2])) {
                let getTable = this.systemTablesService.getTable(element1Tmp.numberSystemTable[index2]).find(v => v.code === element1.answers[index2]);
                if (getTable) {
                  let answer = getTable.name;
                  control.controls[element1Tmp.qNames[index2]].setValue(answer)
                  element1Tmp.answers[index2] = answer
                  element2 = answer
                }
              }
              break;
            case "arrayTable":
              control.controls[element1Tmp.qNames[index2]].controls.forEach((element, index) => {
                let numberSystemTable = element1Tmp.numberSystemTable[0];
                if (numberSystemTable) {
                  numberSystemTable.forEach((elementSys, indexSys) => {
                    if (this.systemTablesService.getTable(element1Tmp.numberSystemTable[0][indexSys])) {
                      let getTable = this.systemTablesService.getTable(element1Tmp.numberSystemTable[0][indexSys]).find(v => v.code === element.value[element1.qNamesSystemTable[0][indexSys]]);
                      if (getTable) {
                        let answer = getTable.name;
                        if (answer) {
                          element.value[element1Tmp.qNamesSystemTable[0][indexSys]] = answer
                          element1Tmp.answers[0][index][element1Tmp.qNamesSystemTable[0][indexSys]] = answer
                        }
                      }
                    }
                  });
                }
              });
              break;
          }

          control = this.buildArray(control, element1Tmp, element2, index2);

          if (this.arrDataBase.length - 1 === index1 && this.showLastSavedQuestion) {
            this.arrDataBase.pop();
          }
          if ((this.arrDataBase.length > index1 && this.showLastSavedQuestion) || !this.showLastSavedQuestion) {
            this.questionnaireService.updateMetaData(currentStep, element1Tmp.qID, element1Tmp.answers);
            this.questionnaireService.saveAndNavigate(currentStep, element1Tmp.qID, element1Tmp.answers);
          }
        });
      }
    });
    if (this.arrDataBase.length > 1) {
      if (this.arrDataBase[this.arrDataBase.length - 1].stepName === currentStep.stepName) {
        this.saveArrDataBasetmp = this.arrDataBase;
        this.autoForm = false;
        this.isBuildForm = true;
      }
    }
    return control;
  }

  buildArray(control, element1, element2, index2) {
    switch ((element1.type)) {
      case "Date":
        if ((element1.type === "Date")) {
          control.controls[element1.qNames[index2]].setValue(this.questionnaireService.customFormat(element2.toString()))
        }
        break;
      case "BorrowersArray":
        control.setControl(element1.qNames[0], this.builBorrowersFromDataBase(element1.answers[0]));
        break;
      case "OtherIncome":
        control.setControl(element1.qNames[0], this.builIncomesFromDataBase(element1.answers[0]));
        break;
      //case "BorrowersAdvancedArray":
      //control.setControl('borrowersAdvancedArray',BorrowersArrayComponent.builAdvancedBorrowersFromDataBase(element.answers[0]));
      //break;
      case "LiabilitiesArray":
        control.setControl(element1.qNames[0], this.buildLiabilitiesFromDataBase(element1.answers[0]));
        break;
      case "Mixture":
        control.setControl(element1.qNames[0], this.buildMixtureFromDataBase(element1.answers[0]));
        break;
      default:
        if (element1.qNames[0] === "borrowersAdvancedArray") {
          control.setControl(element1.qNames[0], this.builAdvancedBorrowersFromDataBase(element1.answers[0]));
        }
        control.controls[element1.qNames[index2]].setValue(element2);
        break;
    }
    return control;
  }

  buildArrDraft(qid, qFields, value, currentStep, isEdit) {
    let findCurrentIndexQ = this.saveArrDataBasetmp.findIndex(arr => arr.stepName === currentStep.stepName && arr.qID === qid);
    if (findCurrentIndexQ !== -1) {
      isEdit = true;
    }
    let q = qFields[qid];
    let qFieldsNames = q.map(r => {
      return r.name;
    });
    let values = q.map(r => {
      return value[r.name];
    });
    let qType = q[0].type;
    let systemTable = q[0].systemTable;
    let qNamesSystemTable = q[0].qNamesSystemTable;
    let numberSystemTable = q[0].numberSystemTable;
    if (qType === "BorrowersArray") {
      values[0].forEach(element => {
        element.borrowerBirthDate = this.questionnaireService.customFormatNgbDateStructToString(element.borrowerBirthDate)
      })
    }
    let arrTmp = []
    if (isEdit) {
      let findCurrentQ = currentStep.questions.filter(arr => arr.questionId === qid);
      if (findCurrentQ[0].isJunction !== true) {
        arrTmp = this.saveArrDataBasetmp.slice(findCurrentIndexQ + 1, this.saveArrDataBasetmp.length)
      }
      this.saveArrDataBasetmp = this.saveArrDataBasetmp.slice(0, findCurrentIndexQ)
    }

    const formattedValues = [];

    for (let i = 0; i < values.length; i++) {
      q[i].type === "Date" ?
        formattedValues.push(this.questionnaireService.customFormatNgbDateStructToString(values[i]))
        : formattedValues.push(values[i]);
    }

    this.saveArrDataBasetmp.push(
      {
        "stepName": currentStep.stepName,
        "qID": qid,
        "qNames": qFieldsNames,
        "type": (qType) ? qType : "String",
        "systemTable": (systemTable) ? systemTable : "",
        "qNamesSystemTable": (qNamesSystemTable) ? qNamesSystemTable : "",
        "numberSystemTable": (numberSystemTable) ? numberSystemTable : "",
        "answers": formattedValues
      })

    this.saveArrDataBasetmp.push(...arrTmp)
    console.log(this.saveArrDataBasetmp);

    if (currentStep.stepName === "user-details" && qid === "4.5") {
      this.createCustomerMainBorrower = [];
      let id: string = this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0];
      let paramsCheckBorrower: CheckBorrower_Request = {
        CustomerId: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0],
        DateOfBirth: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "3")[0].answers[0],
        PrefixPhone: (this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(0, 3))
          ? this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(0, 3) : "",
        PhoneNumber: (this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(3, 10)) ?
          this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(3, 10) : "",
        Email: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4.5")[0].answers[0],
      }
      this.checkBorrower$(paramsCheckBorrower).subscribe(
        // this.checkBorrower$(null).subscribe(
        res => this._checkBorrowerStatus.next(res),
        err => this._checkBorrowerStatus.next(err)
      );
      let userParams: UserEntity = {
        UserId: id,
        IdType: IdTypeEnum.TZ,
        FirstName: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "1")[0].answers[0],
        LastName: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "1")[0].answers[1],
        Phone: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0],
        Email: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4.5")[0].answers[0],
        BirthDate: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "3")[0].answers[0],

      }

      // this.listCreateCustomer.push(params);

      let loanParams: LoanEntity = {
        CustomerIdType: IdTypeEnum.TZ,
        CustomerId: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0],
        PrimaryCustomer: "Y",
        Email: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4.5")[0].answers[0],
        PrefixPhone: (this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(0, 3))
          ? this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(0, 3) : "",
        PhoneNumber: (this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(3, 10)) ?
          this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4")[0].answers[0].substring(3, 10) : ""
      }
      this.createCustomerMainBorrower = [];
      this.mainLoanArrayforCreateOpp = [];
      this.createCustomerMainBorrower.push(userParams);
      this.mainLoanArrayforCreateOpp.push(loanParams);
      this.listCreateCustomerBorrowersArray = [];
      this.listCreateCustomerBorrowersArray.push(...this.createCustomerMainBorrower);
      this.listLoansArrayforCreateOpp = [];
      this.listLoansArrayforCreateOpp.push(...this.mainLoanArrayforCreateOpp);
    }

    /*if (currentStep.stepName === "user-details" && qid === "4.5") {
      const mainLoanArrayforCreateOpp = this.mainLoanArrayforCreateOpp.find(el => el.CustomerId === this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0])
      if (mainLoanArrayforCreateOpp) {
        mainLoanArrayforCreateOpp.Email = this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4.5")[0].answers[0];
      }

      const listLoansArrayforCreateOpp = this.listLoansArrayforCreateOpp.find(el => el.CustomerId === this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0]);
      if (listLoansArrayforCreateOpp) {
        listLoansArrayforCreateOpp.Email = this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "4.5")[0].answers[0];
      }
    }*/

    if (currentStep.stepName === "user-details" && qid === "6" &&
      this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "6")[0].answers[0] === "NO") {
      this.listCreateCustomerBorrowersArray = [];
      this.listCreateCustomerBorrowersArray.push(...this.createCustomerMainBorrower);
      this.listLoansArrayforCreateOpp = [];
      this.listLoansArrayforCreateOpp.push(...this.mainLoanArrayforCreateOpp);
    }

    if (currentStep.stepName === "user-details" && qid === "7") {
      if (this.flagSendToServer) {
        this.listCreateCustomerBorrowersArray = [];
        this.listCreateCustomerBorrowersArray.push(...this.createCustomerMainBorrower);
        this.listLoansArrayforCreateOpp = [];
        this.listLoansArrayforCreateOpp.push(...this.mainLoanArrayforCreateOpp);
      }
      this.flagSendToServer = false;
      this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "7")[0].answers[0].forEach(element => {
        let paramsCheckBorrower: CheckBorrower_Request = {
          CustomerId: element.borrowerIdNumber,
          DateOfBirth: element.borrowerBirthDate,
          PrefixPhone: (element.borrowerPhoneNumber.substring(0, 3)) ? element.borrowerPhoneNumber.substring(0, 3) : "",
          PhoneNumber: (element.borrowerPhoneNumber.substring(3, 10)) ? element.borrowerPhoneNumber.substring(3, 10) : "",
          Email: element.borrowerEmail,
        }
        this.checkBorrower$(paramsCheckBorrower).subscribe(
          // this.checkBorrower$(null).subscribe(
          res => this._checkBorrowerStatus.next(res),
          err => this._checkBorrowerStatus.next(err)
        );
        let userParams: UserEntity = {
          UserId: element.borrowerIdNumber,
          IdType: IdTypeEnum.TZ,
          FirstName: (element.borrowerFullName.split(" ")[0]) ? element.borrowerFullName.split(" ")[0] : "",
          LastName: (element.borrowerFullName.split(" ")[1]) ? element.borrowerFullName.split(" ")[1] : "",
          Phone: element.borrowerPhoneNumber,
          Email: element.borrowerEmail,
          BirthDate: element.borrowerBirthDate
        }
        let loanParams: LoanEntity = {
          CustomerIdType: IdTypeEnum.TZ,
          CustomerId: element.borrowerIdNumber,
          PrimaryCustomer: "N",
          Email: element.borrowerEmail,
          PrefixPhone: (element.borrowerPhoneNumber.substring(0, 3)) ? element.borrowerPhoneNumber.substring(0, 3) : "",
          PhoneNumber: (element.borrowerPhoneNumber.substring(3, 10)) ? element.borrowerPhoneNumber.substring(3, 10) : ""
        }

        this.listCreateCustomerBorrowersArray.push(userParams);
        this.listLoansArrayforCreateOpp.push(loanParams);
      });
    }
    console.log(this.listLoansArrayforCreateOpp)

    if (currentStep.stepName && currentStep.stepName !== "user-details") {
      this.updateDraftData$().subscribe(res => console.log(res));
    }
  }

  getJson(nameFile): Observable<any> {
    return this.httpClient.get("./assets/json-dev/" + nameFile + ".json")
  }

  updateDraftData$() {
    let params: UpdateDraftData = {
      customerId: this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0],
      data: this.saveArrDataBasetmp
    };
    return this.draftHttp.updateDraftData$(params);
  }

  updateSavedDraft(data: any[]) {
    this.saveArrDataBasetmp = data;
  }

  checkBorrower$(params: CheckBorrower_Request) {
    return this.draftHttp.checkBorrower$(params);
  }

  setBorrowers$() {
    this.flagSendToServer = true;
    let params: SetBorrowers_Request = {
      borrowers: this.listCreateCustomerBorrowersArray,
      Loans: this.listLoansArrayforCreateOpp,
      data: this.saveArrDataBasetmp,
      ConsultantId: this.ConsultantId,
      ConsultFirmId: this.ConsultFirmId,
      SourceID: this.leadService.getSourceID()
    }
    return this.draftHttp.setBorrowers$(params);
  }

  clearBorrowersArr() {
    this.saveArrDataBasetmp = [];
    this.arrDataBase = [];
    this.listCreateCustomerBorrowersArray = [];
    this.createCustomerMainBorrower = [];
    this.listLoansArrayforCreateOpp = [];
    this.mainLoanArrayforCreateOpp = [];
  }

  updateOpportunity$(stepNumber) {
    let ifTakeArray1Or2 = 1;
    let PurposeOfLoan = this.saveArrDataBasetmp.filter(arr => arr.stepName === "loan-details" && arr.qID === "1")
    let AmountRequested = this.saveArrDataBasetmp.filter(arr => arr.stepName === "loan-details" && arr.qID === "2")
    let AmountProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "2")
    let CityOfTheProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "1")
    let SignedContract = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "1")
    if (AmountProperty.length === 0) {
      AmountProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "3")
    }
    if (AmountProperty.length === 0) {
      AmountProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "loan-details" && arr.qID === "7")
      ifTakeArray1Or2 = 2;
    }
    let params: UpdateOpportunity_Request = {
      stepNumber: stepNumber,
      ConsultantId: this.ConsultantId,
      ConsultFirmId: this.ConsultFirmId,
      RequiredDate: this.calcDate(),
      SourceID: this.leadService.getSourceID(),
      IsContractSigned: (this.IsContractSigned === "NO") ? "0" : "1",
      PurposeOfLoan: (PurposeOfLoan.length !== 0) ? PurposeOfLoan[0].answers[0] : "0",
      AmountRequested: (AmountRequested.length !== 0) ? AmountRequested[0].answers[0] : "0",
      AmountProperty: (AmountProperty.length !== 0) ? (ifTakeArray1Or2 === 1) ? AmountProperty[0].answers[0] : AmountProperty[0].answers[1] : "0",
      CityOfTheProperty: (CityOfTheProperty.length !== 0) ? CityOfTheProperty[0].answers[0] : "0",
      SignedContract: (SignedContract.length !== 0) ? SignedContract[0].answers[0] === "YES" ? "1" : "0" : "0"
    }

    return this.draftHttp.updateOpportunity$(params);
  }

  sendTMFinal$() {
    let ifTakeArray1Or2 = 1;
    this.SourceID = this.leadService.getSourceID();
    this.CustomerId = this.saveArrDataBasetmp.filter(arr => arr.stepName === "user-details" && arr.qID === "2")[0].answers[0];
    let PurposeOfLoan = this.saveArrDataBasetmp.filter(arr => arr.stepName === "loan-details" && arr.qID === "1")
    let AmountRequested = this.saveArrDataBasetmp.filter(arr => arr.stepName === "loan-details" && arr.qID === "2")
    let AmountProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "2")
    let CityOfTheProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "1")
    let SignedContract = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "1")
    if (AmountProperty.length === 0) {
      AmountProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "3")
    }
    if (AmountProperty.length === 0) {
      AmountProperty = this.saveArrDataBasetmp.filter(arr => arr.stepName === "loan-details" && arr.qID === "7")
      ifTakeArray1Or2 = 2;
    }
    let params: SendTMFinal_Request = {
      Draft: this.saveArrDataBasetmp,
      ConsultantId: this.ConsultantId,
      ConsultFirmId: this.ConsultFirmId,
      CustomerId: this.CustomerId,
      ResponseChannel: (this.questionnaireService.getIsAdvisor()) ? "05" : this.emailOrApp,
      SourceID: this.SourceID,
      RequiredDate: this.calcDate(),
      IsContractSigned: (this.IsContractSigned === "NO") ? "0" : "1",
      PurposeOfLoan: (PurposeOfLoan.length !== 0) ? PurposeOfLoan[0].answers[0] : "0",
      AmountRequested: (AmountRequested.length !== 0) ? AmountRequested[0].answers[0] : "0",
      AmountProperty: (AmountProperty.length !== 0) ? (ifTakeArray1Or2 === 1) ? AmountProperty[0].answers[0] : AmountProperty[0].answers[1] : "0",
      CityOfTheProperty: (CityOfTheProperty.length !== 0) ? CityOfTheProperty[0].answers[0] : "0",
      SignedContract: (SignedContract.length !== 0) ? SignedContract[0].answers[0] === "YES" ? "1" : "0" : "0"
    }

    return this.draftHttp.sendTMFinal$(params);
  }

  restartDraft() {
    this.saveArrDataBasetmp = [];
  }

  calcDate() {
    let filnalDate = "";

    let requiredDate = this.saveArrDataBasetmp.filter(arr => arr.stepName === "property-details" && arr.qID === "6")
    if (requiredDate.length !== 0) {
      let RequiredDate = requiredDate[0].answers[0];
      const today: Date = new Date();
      let calcDate: Date = new Date();

      if (RequiredDate === "בחודש הקרוב") {
        calcDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
        filnalDate = calcDate.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })
      }

      if (RequiredDate === "עד 3 חודשים") {
        const targetMonth: number = today.getMonth() + 2;
        calcDate = new Date(today.getFullYear(), targetMonth + 1, 0)
        filnalDate = calcDate.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })
      }

      if (RequiredDate === "מעל 3 חודשים") {
        const daysToAdd: number = 150;
        const futureDate: Date = new
          Date(today.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
        const futureDay: number = futureDate.getDate();
        const futureMonth: number = futureDate.getMonth() + 1;
        const futureYear: number = futureDate.getFullYear();
        filnalDate = `${futureDay}/${futureMonth}/${futureYear}`;
      }
    }
    return filnalDate;
  }

  builBorrowersFromDataBase(value: any) {
    let arr: FormGroup[] = [];
    if (value && value.length > 0) {
      value.forEach(element => {
        if (element.borrowerIdNumber) {
          const dateParts = element.borrowerBirthDate.trim().split('/');
          let borrowerBirthDate = { day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2]) };
          arr.push(new FormGroup({
            borrowerFullName: new FormControl(element.borrowerFullName || ""),
            borrowerPhoneNumber: new FormControl(element.borrowerPhoneNumber || ""),
            borrowerBirthDate: new FormControl(borrowerBirthDate || ""),
            borrowerIdNumber: new FormControl(element.borrowerIdNumber || ""),
            borrowerProximity: new FormControl({ value: element.borrowerProximity || "", disabled: element.borrowerProximity === "בן/ בת זוג" ? true : false }),
            borrowerId: new FormControl(element.borrowerId || ""),
            borrowerEmail: new FormControl(element.borrowerEmail || "")
          }))
        }
      });
    }
    return new FormArray(arr);
  }

  builAdvancedBorrowersFromDataBase(answer: any) {
    if (answer) {
      let advanceBorrowersFormArr: FormGroup[] = [];
      answer.forEach(element => {
        console.log(element);
        let zugDisable = element.borrowerMaritalStatus === "נשוי/ה" ? true : false;
        advanceBorrowersFormArr.push(new FormGroup({
          borrowerFullName: new FormControl({
            value: element.borrowerFullName || "",
            disabled: true
          }),
          // borrowerAddress: new FormControl({
          //   value: element.borrowerAddress || "",
          //   disabled: zugDisable
          // }),
          borrowerChildrenNumber: new FormControl({
            value: element.borrowerChildrenNumber || "",
            disabled: zugDisable
          }),
          borrowerMaritalStatus: new FormControl({
            value: element.borrowerMaritalStatus,
            disabled: zugDisable
          }),
          borrowerId: new FormControl(element.borrowerId || "")
        }))
      });
      return new FormArray(advanceBorrowersFormArr);
    }
  }

  builIncomesFromDataBase(value: any) {
    let arr: FormGroup[] = [];
    if (value && value.length > 0) {
      value.forEach(element => {
        if (element.type) {
          arr.push(new FormGroup({
            type: new FormControl(element.type || ""),
            amount: new FormControl(element.amount || ""),
            source: new FormControl(element.source || ""),
          }))
        }
      });
    }
    return new FormArray(arr);
  }

  buildLiabilitiesFromDataBase(value: any) {
    let arr: FormGroup[] = [];
    if (value && value.length > 0) {
      value.forEach(element => {
        let flag: boolean = false;
        if (element) {
          if (element.liabilityType === "מזונות" || element.liabilityType === "שכר דירה") {
            flag = true;
          }
        }
        arr.push(new FormGroup({
          liabilityType: new FormControl({ value: element.liabilityType || "", disabled: flag }),
          liabilityBalance: new FormControl(element.liabilityBalance || ""),
          liabilityMonthlyRefund: new FormControl(element.liabilityMonthlyRefund || ""),
          liabilityEndDate: new FormControl(element.liabilityEndDate || ""),
          required: new FormControl(element.required || false)
        }));
      });
    }
    return new FormArray(arr);
  }

  buildMixtureFromDataBase(value: any) {
    let arr: FormGroup[] = [];
    if (value && value.length > 0) {
      value.forEach(element => {

        arr.push(new FormGroup({
          type: new FormControl(element.type || ""),
          amount: new FormControl(element.amount || ""),
          period: new FormControl(element.period || ""),
          ribit: new FormControl(element.ribit || "")
        }));
      });
    }
    return new FormArray(arr);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/draft.service.ts